import React from 'react';

// VAF ve PSI garanti uyarı banner'ları birebir aynı yapıdaydı (FormWarrantyClaims.jsx içinde
// iki kez kopyalanmıştı) - tek component'e indirildi, `type` prop'u ile başlık/metin değişiyor.
// Metinler orijinaliyle birebir aynı bırakıldı (i18n'e taşınmadı) - sadece yapısal çıkarım.
const WarrantyWarningBanner = ({ type, claims }) => {
    if (!claims || claims.length === 0) return null;

    return (
        <div className="col-12">
            <div className="p-3 border-round border-1" style={{ backgroundColor: '#fff8e1', borderColor: '#f59e0b' }}>
                <div className="flex align-items-center mb-2">
                    <i className="pi pi-exclamation-triangle mr-2" style={{ color: '#f59e0b', fontSize: '1.2rem' }}></i>
                    <span className="font-bold" style={{ color: '#b45309' }}>
                        {type} Garanti Uyarısı
                    </span>
                </div>
                <p className="mt-0 mb-2 text-sm" style={{ color: '#92400e' }}>
                    Bu şasi için daha önce oluşturulmuş {claims.length} adet {type} garanti talebi bulundu:
                </p>
                <div className="flex flex-column gap-1">
                    {claims.map((claim) => (
                        <div key={claim.id} className="flex align-items-center justify-content-between p-2 border-round" style={{ backgroundColor: '#fefce8' }}>
                            <span className="font-semibold text-sm">
                                {claim.warrClaimsNo} - {claim.statusDesc}
                            </span>
                            <span className="text-sm" style={{ color: '#78716c' }}>
                                {claim.claimDate ? new Date(claim.claimDate).toLocaleDateString('tr-TR') : '-'} | {claim.totalPrice != null ? `${claim.totalPrice.toFixed(2)} ${claim.currency || ''}`.trim() : '-'}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WarrantyWarningBanner;
